import EmptyState from "./EmptyState";

export default EmptyState;
